import ManageButtonsHeader from "./ManageButtonsHeader";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import React from "react";
import DisplayView from "../../../../../components/DisplayView";
import DateFilter from "../../../Company/Payroll/Subcomponents/DateFilter";
import {VIEW_TYPE} from "../../../../../enums/ViewType";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const TotalMealsHeader= (props) => {
    const {
        subView,
        subViewChild,
        setSubViewChild,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        setResults,
        results,
        option,
        rowsPerPage,
        attendanceStartDate,
        attendanceEndDate,
        selectedOption,
        setSelectedOption,
        setRender,
        selectedDate,
        setSelectedDate,
        finalArray,
        handleChange
    } = props;

    return (
        <>
            <div className='d-flex gap-3'>
                <ManageButtonsHeader
                    subView={subView}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                />
                { subViewChild === VIEW_TYPE.LIST.name &&
                    <div className='flex-grow-1'>
                        <SearchSimple
                            id={'txt_m_search'}
                            setBodyForExport={setBodyForExport}
                            setSearchResults={(e) => {
                                if(setRender) setRender('');
                                setResults(e);
                            }}
                            searchResults={results}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            optionTable={option}
                            rowsPerPage={rowsPerPage}
                            setSearch={setSearch}
                            contractorId={null}
                            supplierId={null}
                            attendanceStartDate={attendanceStartDate}
                            attendanceEndDate={attendanceEndDate}
                            attendanceSearchType={selectedOption}
                            setSimpleSearch={setSimpleSearch}
                        />
                    </div>
                }
            </div>
            {/* Top row with view toggle and date filter */}
            <div className={`col-12 d-flex ${subViewChild === VIEW_TYPE.LIST.name ? "mt-4" : "mt-38px"}`}>
                {/* DisplayView component allows switching between List and Grid views */}
                <DisplayView view={subViewChild} setView={setSubViewChild} className={''} />
                {/* className empty to remove margin-left property in DisplayView */}

                {finalArray?.length <= 0 &&
                    <div className={"w-100"}>
                        <DateFilter
                            selectedOption={selectedOption}
                            setSelectedOption={setSelectedOption}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            handleChange={handleChange}
                        />
                    </div>
                }
            </div>
        </>
    );
};
export default TotalMealsHeader
